export default "__VITE_ASSET__BjpupmBw__"